import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class TextTemplateContent extends Vue {

  state = new PageState()

  created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
  }

  /** 删除文字模板 */
  handleDeleteTemplate() {
    this.state.operatingTextTemplate = {
      // 模板 id
      id: null,
      // 文字模板的文本
      text: '',
      // 缩放比例
      scale: 1,
      // 素材宽度
      width: 0,
      // 素材高度
      height: 0,
      // x 轴距离 %
      x: 0,
      // Y 轴距离 %
      y: 0
    }
    this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
  }

  /** 选择文字模板 */
  handleSelectTemplate(item) {
    if (this.state.operatingTextTemplate.id === item.id) return
    this.state.operatingTextTemplate.id = item.id
    this.state.operatingTextTemplate.text = (
      this.state.operatingTextTemplate.id === this.state.savedTextTemplate.id
        ? this.state.savedTextTemplate.text
        : item.text
    )
    this.state.operatingTextTemplate.x = 0.04
    this.state.operatingTextTemplate.y = 0.1
    // 设置编辑状态
    this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, true)
    // 获取文字模板图片宽高
    let image = document.createElement("img") as HTMLImageElement
    image.setAttribute("src", item.templateUrl);
    image.addEventListener("load", () => {
      this.state.operatingTextTemplate.width = image.naturalWidth / 2
      this.state.operatingTextTemplate.height = image.naturalHeight / 2
      console.log('getCoverInfo', this.state.operatingTextTemplate.width, this.state.operatingTextTemplate.height)
    });
    image.addEventListener("error", (error) => {
      console.error("图片加载失败", error);
    });
  }

}